import { stationsActions } from '../reducer';

type Operation = () => void;

export const resetDeleteFavouriteStationsStatus: Operation = () => stationsActions
  .resetDeletingStatus();
